import React, { FC } from 'react';
import { useObserver } from 'mobx-react-lite';
import { useRootStore } from '../root/RootStoreHooks';
import { EnrollmentRootStore } from '../root/EnrollmentRootStore';
import { Currency, formatCurrencyAmount } from '../../reference/Currency';

interface Props {
  price: number;
  quantity: number;
  totalPrice: number;
  currencyCode?: string;
  currencySymbol?: string;
}

const renderWithCurrency = (price: number, quantity: number, totalPrice: number, currency: Currency) => (
  <>
    {currency.symbol}
    {currency.formatDisplayAmount(price)}
    <span> x </span>
    {quantity}
    <span> = </span>
    {currency.symbol}
    {currency.formatDisplayAmount(totalPrice)}
    <small> {currency.code}</small>
  </>
);

const renderWithoutCurrency = (price: number, quantity: number, totalPrice: number, currencySymbol: string, currencyCode:string) => (
  <>
    {currencySymbol}
    {formatCurrencyAmount(price, currencyCode)}
    <span> x </span>
    {quantity}
    <span> = </span>
    {currencySymbol}
    {formatCurrencyAmount(totalPrice, currencyCode)}
    <small> {currencyCode}</small>
  </>
);

export const DetailedMoneyDisplay: FC<Props> = ({ price, quantity, totalPrice, currencyCode, currencySymbol }) => {
  const rootStore = useSafeRootStore();
  return useObserver(() => {
    if (!rootStore && currencyCode && currencySymbol) {
      return renderWithoutCurrency(price, quantity, totalPrice, currencySymbol, currencyCode );
    } else if (rootStore) {
      const { currency } = rootStore.reference;
      return renderWithCurrency(price, quantity, totalPrice, currency);
    } else {
      return <div/>;
    }
  });
};

export const useSafeRootStore = (): EnrollmentRootStore | undefined => {
  try {
    return useRootStore();
  } catch (e) {
    console.error('Root store not found:', e);
    return undefined;
  }
};
